var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bjffff"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"contentBox"},[_c('div',{staticClass:"contTitle"},[_vm._v(_vm._s(_vm.info.name))]),_c('div',{staticClass:"contTxt",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }